import { db } from "../firebaseSetup";
import { DocumentData, DocumentSnapshot, setDoc } from "firebase/firestore";
import { doc } from "firebase/firestore";
import { getDoc } from "firebase/firestore";


export class RecommendationTracker {
    public static async trackRecommendation(code: string, id: string) {
        var key = 1;
        switch (code) {
            case 'linkClicked': key = 1;
                break;
            case 'contactFormSent': key = 2;
                break;
            default: key = 1;
                break;
        }

        const now = new Date();
        const isoString = now.toISOString();
        if (key !== 1 && key !== 2) {
            return;
        }
        let recSnap: DocumentSnapshot<DocumentData, DocumentData> | undefined;
        try {
            recSnap = await getDoc(doc(db, "recommendations", id));
            if (!recSnap.exists()) {
                return;
            }
        } catch (error) {
            console.error("Fehler beim Abrufen der Empfehlung:", error);
        }

        const data = recSnap?.data();
        const statusTimestamps = data?.statusTimestamps || {};
        statusTimestamps[key] = isoString;

        try {
            await setDoc(doc(db, 'recommendations', id), {
                statusLevel: code,
                statusTimestamps: statusTimestamps
            }, { merge: true });
        }
        catch (error) {
            console.error("Fehler beim Aktualisieren der Empfehlung:", error);
        }
    }

}